import './scss/index.scss';
import { dcFactory } from 'dc';
import ProfileDropdownComponent from './js/profile-dropdown.component';

dcFactory.register(ProfileDropdownComponent);
